<template>
    <!-- 弹出框新增 -->
    <el-dialog
        :close-on-click-modal="false"
        class="dialog-container"
        :title="title"
        :visible.sync="show"
        width="1000px"
        :before-close="clearadddata"
    >
        <el-form
            ref="addfrom"
            :rules="rules"
            :model="addfrom"
            v-loading="dialogLoading"
        >
            <div class="dialog-box">
                <div class="dialog-left">
                    <el-form-item
                        label-width="180px"
                        label="组织名称:"
                        prop="name"
                        style="margin-top: 20px"
                    >
                        <el-input
                            class="input70"
                            v-model="addfrom.name"
                            :disabled="typeString == 'look'"
                            placeholder="请输入组织名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="组织类型"
                        label-width="180px"
                        prop="type"
                        style="margin-top: 20px"
                    >
                        <el-select
                            :disabled="typeString == 'look'"
                            class="input70"
                            v-model="addfrom.type"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label-width="180px"
                        label="组织介绍"
                        style="margin-top: 20px"
                    >
                        <el-input
                            :disabled="typeString == 'look'"
                            @input="descInput"
                            style="position: relative; margin-bottom: 5px"
                            class="input70"
                            maxlength="200"
                            v-model="addfrom.introduce"
                            type="textarea"
                        ></el-input
                        ><br />
                    </el-form-item>
                    <el-form-item
                        label-width="180px"
                        label="地址"
                        style="margin-top: 20px"
                    >
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                                margin-bottom: 15px;
                            "
                        >
                            <el-select
                                class="addres_input"
                                :disabled="typeString == 'look'"
                                v-model="addfrom.province"
                                style="margin-right: 20px"
                                placeholder="请选择"
                            >
                                <el-option
                                    label="天长市"
                                    :value="1"
                                ></el-option>
                            </el-select>
                            <el-select
                                class="addres_input"
                                :disabled="typeString == 'look'"
                                style="margin-right: 20px"
                                @change="getAddressByParentId"
                                v-model="addfrom.city"
                                placeholder="请选择"
                            >
                                <el-option
                                    label="浔河社区"
                                    :value="2"
                                ></el-option>
                                <el-option
                                    label="石街社区"
                                    :value="20"
                                ></el-option>
                            </el-select>
                            <el-select
                                class="addres_input"
                                :disabled="typeString == 'look'"
                                v-model="areaId"
                                @change="changeArea"
                                placeholder="选择网格"
                                style="width: 174px"
                            >
                                <el-option
                                    v-for="item in gridCode"
                                    :key="item.id"
                                    :label="item.orgName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                        <div style="display: flex; margin-bottom: 15px">
                            <el-input
                                :disabled="typeString == 'look'"
                                class="input70"
                                v-model="addfrom.address"
                                @blur="transLocation"
                            ></el-input>
                        </div>
                        <div style="display: flex; margin-bottom: 15px">
                            <div
                                id="container"
                                class="input70"
                                style="height: 200px; margin-bottom: 30px"
                            ></div>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label-width="180px" label="详细地址" prop="address" style="margin-top:35px;">
              <el-input
                  :disabled="typeString == 'look'"
                  v-model="addfrom.address"
                  placeholder="请输入详细地址"
                 
                  class="input70"
              ></el-input>
          </el-form-item>
          <el-form-item label-width="180px" label="手动选择地址" >
              <div id="container"  class="input70" style="height:200px;margin-bottom: 30px;"></div>
          </el-form-item>  -->
                    <el-form-item label-width="180px" label="选择组织成员">
                        <el-button
                            :disabled="typeString == 'look'"
                            type="primary"
                            size="mini"
                            @click="getmenberList()"
                            >添加组织成员
                        </el-button>
                    </el-form-item>
                </div>
            </div>
            <el-dialog
                title="选择人员"
                :visible.sync="dialogPeopleVisible"
                width="50%"
                :before-close="handleClose"
                append-to-body
            >
                <el-form
                    :inline="true"
                    :model="searchPeopleList"
                    class="demo-form-inline"
                    size="mini"
                >
                    <el-form-item label="人员姓名:" style="margin: 0 30px 0 0">
                        <el-input
                            v-model="searchPeopleList.name"
                            placeholder="请输入人员姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getrenyuaInfo"
                            >查询</el-button
                        >
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="searchPeopleReset"
                            >重置</el-button
                        >
                    </el-form-item>
                    <el-form-item></el-form-item>
                </el-form>
                <!-- <el-table :data="tableData"
                  ref="multipleTable"
                  :header-cell-style="{ background: '#f8fafa' }"
                  border
                  align="center"
                  @select="handleSelectionsChange"
                  @select-all="handleSelectionsChange"
                  current-row-key
                  highlight-current-row> -->
                <el-table
                    :data="tableData"
                    ref="multipleTable"
                    :header-cell-style="{ background: '#f8fafa' }"
                    border
                    align="center"
                    @select="handleSelectionsChange"
                    @select-all="handleSelectionsChange"
                    :row-key="getRowKeys"
                    highlight-current-row
                >
                    <el-table-column
                        type="selection"
                        align="center"
                        :reserve-selection="true"
                    ></el-table-column>
                    <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="name"
                        width="180"
                        label="姓名"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="sex"
                        width="60"
                        label="性别"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex == 1">女</span>
                            <span v-if="scope.row.sex == 0">男</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="parentPersonTypeName"
                        label="类别"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <!-- <el-table-column prop="photoPath" label="人员图片" align="center">
            <template slot-scope="scope">
              <img :src="scope.row.photoPath" alt style="width:50px;height:50px" />
            </template>
          </el-table-column> -->
                </el-table>
                <el-pagination
                    :page-size="pageConfig.pageSize"
                    layout="total, prev, pager, next, jumper"
                    @current-change="handleCurrentChange"
                    :total="pageConfig.total"
                ></el-pagination>
                <div slot="footer" class="dialog-footer clacenter">
                    <el-button @click="dialogPeopleVisible = false"
                        >取 消</el-button
                    >

                    <el-button type="primary" @click="addMember()"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
            <!-- 循环添加成员模块 -->
            <el-form-item label-width="180px" label="组织成员">
                <el-table
                    class="input70"
                    :data="member"
                    ref="multipleTable"
                    :header-cell-style="{ background: '#f8fafa' }"
                    border
                    align="center"
                    current-row-key
                    highlight-current-row
                >
                    <el-table-column
                        type="index"
                        align="center"
                        label="序号"
                        width="50"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="name"
                        label="姓名"
                    ></el-table-column>
                    <el-table-column align="center" prop="post" label="职位">
                        <template slot-scope="scope">
                            <span v-if="scope.row.post == 0">党委书记</span>
                            <span v-if="scope.row.post == 1">党委副书记</span>
                            <span v-if="scope.row.post == 2">记检委员</span>
                            <span v-if="scope.row.post == 3">组织委员</span>
                            <span v-if="scope.row.post == 4">其他委员</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sort"
                        label="排序"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        fixed="right"
                        label="操作"
                        width="150"
                    >
                        <template slot-scope="scope">
                            <el-button
                                @click="lookdata(scope.row, 'look')"
                                type="text"
                                size="small"
                                >查看</el-button
                            >
                            <el-button
                                @click="lookdata(scope.row, 'edit')"
                                v-if="typeString != 'look'"
                                type="text"
                                size="small"
                                >编辑</el-button
                            >
                            <el-button
                                @click="deletdata(scope.$index, 'delet')"
                                v-if="typeString != 'look'"
                                type="text"
                                size="small"
                                >删除</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogPersonInfo"
                width="50%"
                :before-close="handleClose"
                append-to-body
            >
                <el-form
                    :model="ruleForm"
                    status-icon
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                >
                    <el-form-item label="姓名">
                        <el-input
                            disabled
                            class="winput450"
                            v-model="ruleForm.name"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="职位">
                        <el-select class="winput450" v-model="ruleForm.post">
                            <el-option label="党委书记" value="0"></el-option>
                            <el-option label="党委副书记" value="1"></el-option>
                            <el-option label="记检委员" value="2"></el-option>
                            <el-option label="组织委员" value="3"></el-option>
                            <el-option label="其他委员" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input
                            :disabled="diabletwo"
                            class="winput450"
                            v-model="ruleForm.sort"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="图片：" prop="photo">
                        <div class="threestyleimg">
                            <div class="threestyleimgtu">
                                <img
                                    :src="ruleForm.photo"
                                    alt
                                    style="width: 170px; height: 150px"
                                />
                            </div>
                            <div class="threestyleimgbtn">
                                <div>上传照片</div>
                                <input type="file" @change="upimg" />
                                <!-- <el-button @click="deleteImg">删除</el-button> -->
                            </div>
                            <div class="el-upload__tip" slot="tip">
                                友情提示:只能上传一个照片,且照片大小不能超过10M
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer clacenter">
                    <el-button @click="editMember()">取 消</el-button>
                    <el-button type="primary" @click="editMember()"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
            <el-form-item
                label-width="180px"
                label="组织主图:"
                prop="photo"
                style="margin-top: 30px"
            >
                <template class="input70" v-if="typeString === 'look'">
                    <el-image
                        v-for="(item, index) in addfrom.photo"
                        :key="index"
                        style="width: 120px; height: 120px; margin: 10px"
                        :src="item"
                        :preview-src-list="addfrom.photo"
                    >
                    </el-image>
                </template>
                <el-upload
                    v-else
                    :class="{ hide: hideUpload }"
                    :action="actionUrl"
                    list-type="picture-card"
                    :on-preview="handlePicturePreview"
                    :on-success="
                        (data, data1, data2) =>
                            imgSuccess('photo', data, data1, data2)
                    "
                    :file-list="photo"
                    :on-remove="
                        (file, fileList) =>
                            handleRemove2('photo', file, fileList)
                    "
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible1">
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
            </el-form-item>
            <el-form-item
                label-width="180px"
                label="状态:"
                style="margin: 0 30px 0 0; height: 50px"
            >
                <el-radio-group
                    v-model="addfrom.status"
                    :disabled="typeString === 'look'"
                >
                    <el-radio :disabled="typeString == 'look'" label="0"
                        >启用</el-radio
                    >
                    <el-radio :disabled="typeString == 'look'" label="1"
                        >禁用</el-radio
                    >
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div class="boontbtn" v-if="typeString !== 'look'">
            <el-button
                type="primary"
                size="small"
                style="margin: 0 30px"
                @click="validateForm"
                >保存</el-button
            >
            <el-button type="info" size="small" @click="clearadddata"
                >取消</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import {
    findPartyOrgBuildById,
    insertPartyOrgBuild,
    updatePartyOrgBuild,
    findAddressByParentId,
    uploadPartyPhoto,
} from "@/api/http"
import Editor from "@/components/quillEditorCom2"
import Address from "@/component/addressMapCom3"
import { post } from "@/api/requrestHttp"
import { addressMix } from "@/mixins/addressMix.js"
import AMap from "AMap" // 引入高德地图

export default {
    mixins: [addressMix],
    components: {
        Editor,
        Address,
    },
    props: {
        streetTree: {
            type: Array,
            default() {
                return []
            },
        },
        show: {
            type: Boolean,
            default: false,
        },
        id: {
            type: Number,
            default: 0,
        },
        typeString: {
            type: String,
            default: "insert",
        },
        partyTree: {
            type: Array,
            default() {
                return []
            },
        },
        parentData: {
            type: Object,
            default() {
                return {}
            },
        },
        addMemberData: {
            type: Array,
            default() {
                return []
            },
        },
        addMemberDatas: {
            type: Array,
            default() {
                return []
            },
        },
    },
    watch: {
        id(val) {
            if (val) {
                this.getDetail(val)
            } else {
                this.initForm()
                this.setMap()
            }
        },
    },
    computed: {
        title() {
            return this.typeString === "insert"
                ? "新增"
                : this.typeString === "update"
                ? "修改"
                : "查看"
        },
        readOnly2() {
            if (this.readonly) {
                return true
            }
            return false
        },
    },
    data() {
        return {
            ruleForm: {
                id: "",
                name: "",
                post: "",
                sort: "",
                photo: [],
            },
            options: [
                { label: "可由村级协商委员会负责协商", value: "0" },
                { label: "村干部为组长的下属协商委员会负责协商", value: "1" },
                { label: "村协商委员会主任牵头组织协商", value: "2" },
                { label: "镇党委、政府指定镇负责同志牵头组织协商", value: "3" },
                { label: "第三方组织", value: "4" },
            ],
            readonly: false,
            hideUpload: false,
            imgupdataimg: "",
            remnant: 0, //输入数
            searchPeopleList: {},
            diabletwo: false,
            dialogVisible: false,
            uploadDisabled: false,
            dialogPersonInfo: false,
            dialogTitle: "查看",
            eddimgurl: require("@/assets/images/partyMemberManagementcopy/imgjia.png"),
            actionUrl:
                "http://36.33.216.70:5665/api/controller/uploadVotePic/info/uploadPartyPhoto",
            dialogPeopleVisible: false,
            dialogLoading: false,
            gridCode: [],
            areaId: "",
            addfrom: {
                photo: [],
            },
            tableData: [],
            selectListData: [], //需要回显的数据id数组
            photo: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入组织名称",
                        trigger: "blur",
                    },
                ],
                photo: [
                    {
                        required: true,
                        message: "请选择组织主图",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择组织类型",
                        trigger: "blur",
                    },
                ],
            },
            suoshuzuzhi: [],
            mapOptions: {
                labeltext: "活动地址:",
                mapid: "addMap",
                city: "cityName",
                area: "areaName",
                street: "streetName",
            },
            baseForm: {
                smallAreaId: [],
            },
            anarry: {
                addressStreetId: "",
                addressCityId: "",
                addressAreaId: "",
                addressStreetName: "",
                addressCityName: "",
                addressAreaName: "",
            },
            mapData: {},
            zhengshuji: [],
            fushuji: [],
            member: [{}],
            checkedData: [],
            multipleSelection: {},
            multipleSelectionFarher: {},
            multipleSelectionClick: {},
            fileList: [],
            zuzhiId: "", // 选择所属组织Id,
            dialogVisible1: false, // 上传模态框按钮
            dialogImageUrl: "", //图片上传
            fileListimg: [],
            imgTitleList: ["photo"],
            checktableList: [],
            pageConfig: {
                pageSize: 5,
                total: 0,
                pageNo: 1,
            },
            tempData: [],
        }
    },
    methods: {
        //问题二、数据回显问题
        getRowKeys(row) {
            return row.id
        },
        getmenberList() {
            this.dialogPeopleVisible = true
            //问题三、表格数据显示问题,把下面两句注释掉即可
            // this.member = []
            this.multipleSelection = []
        },
        changeArea(val) {
            console.log(val)
            this.addfrom.area = val
            console.log("this.addfrom.area", this.addfrom.area)
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row)
                })
            } else {
                // this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionsChange(val) {
            this.multipleSelectionClick[this.pageConfig.pageNo] = val.length + 1
            this.multipleSelection[this.pageConfig.pageNo] = val
            console.log(this.multipleSelection[this.pageConfig.pageNo])
            this.tempData = val
        },
        clearadddata() {
            this.initForm()
            this.$emit("close", true)
            this.checktableList = []
            this.hideUpload = false
            // this.$refs.map.destroyMap();
        },
        // Editor文字修改
        editorUpdate(val, item) {
            item.introduce = val
        },
        getUserInfo() {
            let id = this.$store.state.id
            post("/admin/user/info/getLoginUserInfo", { id: id }).then(
                (res) => {
                    if (res.code == "200") {
                        this.zuzhiId = res.content.user.orgId
                    }
                }
            )
        },
        // 副书记
        addFushuji() {
            this.fushuji.push(this.getFushuji())
        },
        f() {
            return {
                // id:this.leadersId.memberId,
                photo: "",
                name: "",
                introduce: "",
                post: "",
            }
        },
        //编辑成员信息
        editMember() {
            this.dialogPersonInfo = false
            this.updataPersonImg()
        },
        //去除数组中重复对象
        deteleObject(obj) {
            var uniques = []
            var stringify = {}
            for (var i = 0; i < obj.length; i++) {
                var keys = Object.keys(obj[i])
                keys.sort(function (a, b) {
                    return Number(a) - Number(b)
                })
                var str = ""
                for (var j = 0; j < keys.length; j++) {
                    str += JSON.stringify(keys[j])
                    str += JSON.stringify(obj[i][keys[j]])
                }
                if (!stringify.hasOwnProperty(str)) {
                    uniques.push(obj[i])
                    stringify[str] = true
                }
            }
            uniques = uniques
            return uniques
        },
        //成员
        addMember() {
            this.dialogPeopleVisible = false
            console.log(666, this.multipleSelection)
            let newdata = []
            for (const key in this.multipleSelection) {
                if (this.multipleSelection.hasOwnProperty(key)) {
                    newdata = newdata.concat(this.multipleSelection[key])
                }
            }
            console.log(777, newdata)
            newdata.forEach((item) => {
                this.member.push({
                    personId: item.personId,
                    name: item.name,
                    post: item.post,
                    photo: item.photoPath,
                    sort: item.sort,
                })
                console.log(123, this.member)
            })
            //问题一、去除重复对象数组
            var myData = this.tempData
            var member1 = []
            this.member = this.deteleObject(myData)
            this.member.forEach((item) => {
                member1.push({
                    personId: item.id,
                    name: item.name,
                    post: item.post,
                    photo: item.photoPath,
                    sort: item.sort,
                })
            })
            this.member = []
            this.member = member1
            console.log("this.member====", this.member)
        },

        // resetForm(formName) {
        //     this.$refs[formName].resetFields();
        // },
        // 副书记数据格式
        getFushuji() {
            return {
                photo: "",
                name: "",
                sort: "",
                post: "",
            }
        },
        lookdata(data, type) {
            console.log(data)
            this.imgupdata = data.personId
            console.log(this.imgupdata)
            this.dialogPersonInfo = true
            this.ruleForm = data
            console.log(data.photo)
            this.eddimgurl = data.photo
            if (type == "look") {
                this.diabletwo = true
            } else if (type == "edit") {
                this.diabletwo = false
            }
        },
        deletdata(index) {
            console.log(index)
            this.member.splice(index, 1)
            //表格数据删除后对话框前的勾选也删除
        },
        //计算输入数
        descInput() {
            var txtVal = this.addfrom.introduce.length
            this.remnant = txtVal
        },
        async getDetail(id) {
            this.hideUpload = false
            const { content } = await new Promise((resolve) => {
                findPartyOrgBuildById(id).then((res) => {
                    resolve(res)
                    if (res.code == 200) {
                        this.getAddressByParentId(res.content.city)
                    }
                })
            })
            new Promise((resolve) => {
                findAddressByParentId({ id: 1 }).then((res) => {
                    resolve(res)
                    this.option12 = res.content.list
                })
            }).then((res) => {
                new Promise((resolve) => {
                    findAddressByParentId({ id: 2 }).then((res1) => {
                        resolve(res1)
                        this.option13 = res1.content.list
                    })
                }).then((res1) => {
                    new Promise((item) => {
                        findAddressByParentId({ id: 3 }).then((res2) => {
                            this.option14 = res2.content.list
                        })
                    })
                })
            })
            this.imgTitleList.forEach((item, index) => {
                if (content[item] == null) {
                    content[item] = "#"
                }
                // console.log(content[item])
                content[item] = content[item].split("#")
                content[item].map((item1, index) => {
                    if (item1 == "") {
                        content[item].splice(index, 1)
                    }
                })
            })
            // 回显图片
            this.imgTitleList.forEach((item) => {
                if (content[item] && Array.isArray(content[item])) {
                    content[item].forEach((item2) => {
                        this[item].push({
                            name: item2.substring(item2.length - 20),
                            url: item2,
                        })
                    })
                }
            })
            console.log("content", content)
            this.$set(this.baseForm, "cityName", content.addressStreetId)
            this.$set(this.baseForm, "areaName", content.addressCityId)
            this.$set(this.baseForm, "streetName", content.addressAreaId)
            this.addfrom = content
            this.$set(this.addfrom, "introduce", content.introduce)
            this.areaId = content.areaName
            console.log("修改前", this.addfrom)
            if (this.addfrom.photo) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            console.log("areaId", this.areaId)
            this.fileList = [] //清空正书记的图片
            this.fushuji = [] //清空副书记的图片
            this.member = []
            content.leaders.forEach((item) => {
                this.member.push({
                    personId: item.personId,
                    photo: item.photo,
                    name: item.name,
                    post: item.post,
                    sort: item.sort,
                })
            })
            this.member.sort(this.creatCompare("post"))
        },
        creatCompare(propertyName) {
            return function (obj1, obj2) {
                const value1 = obj1[propertyName]
                const value2 = obj2[propertyName]
                // console.log(obj1)
                if (value1 < value2) {
                    return -1
                } else if (value1 > value2) {
                    return 1
                } else {
                    return 0
                }
            }
        },
        // 删除成员
        deleteMember(index) {
            this.$confirm("此操作将删除该成员, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                console.log(this.member)
                this.member.splice(index, 1)
                // console.log(this.member);
            })
        },
        deleteFushuji(index) {
            this.fushuji.splice(index, 1)
        },
        getLeaderData(item) {
            return {
                id: item.id,
                name: item.name,
                photo: item.photo,
                sort: item.sort,
                post: item.post,
            }
        },
        handleLeader(arr) {
            let zheng
            const fuArr = []
            arr.forEach((item) => {
                if (item.post === "3") {
                    memberArr.push(this.getLeaderData(item))
                }
                if (item.post === "2") {
                    fuArr.push(this.getLeaderData(item))
                } else if (item.post === "1") {
                    zheng = this.getLeaderData(item)
                }
            })
            this.fushuji = fuArr
            this.member = memberArr
            return zheng
        },
        setMap(id = 0) {
            this.mapOptions = {
                labeltext: "活动地址:",
                mapid: `mapid${id}`,
                city: "cityName",
                area: "areaName",
                street: "streetName",
            }
        },
        initForm() {
            this.addfrom = {
                higherOrganize: "",
                name: "",
                level: null,
                streetId: "",
                communityId: "",
                address: "",
                longitude: "",
                latitude: "",
                status: "0",
                linkMain: "",
                linkPhone: "",
                linkAddr: "",
                photo: [],
            }
            this.photo = ""
            this.fileList = []
            this.fileListimg = []
            this.mapData = {}
            this.zuzhiId = null
            this.fushuji = []
        },
        // 上传照片相关
        shujiAvatar(res, file, item) {
            this.$set(item, "photo", item.photo + ";" + res.content.pash)
            item.photo = res.content.path
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === "image/jpeg";
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isJPG) {
            //   this.$message.error("上传头像图片只能是 JPG 格式!");
            // }
            // if (!isLt2M) {
            //   this.$message.error("上传头像图片大小不能超过 2MB!");
            // }
            // return isJPG && isLt2M;
        },
        // 地图方法
        addressMapBack(data, key) {
            const newData = Object.assign({}, data)
            newData.longitude = newData.longitude
                ? newData.longitude + ""
                : null
            newData.latitude = newData.latitude ? newData.latitude + "" : null
            this[key] = Object.assign(this[key], newData)
        },
        handleClose(done) {
            done()
        },
        // 提交
        validateForm() {
            this.$refs.addfrom.validate((valid) => {
                if (valid) {
                    this.submit()
                }
            })
        },
        handleImgPost() {
            this.imgTitleList.forEach((element, index) => {
                let str = ""
                if (
                    this.addfrom[element] &&
                    Array.isArray(this.addfrom[element])
                ) {
                    this.addfrom[element].map((item, index) => {
                        str += item + "#"
                    })
                } else {
                    str = this.addfrom[element]
                }
                this.addfrom[element] = str
            })
        },
        // 获取地址下拉
        getAddressByParentId(addId) {
            console.log("addId", addId)
            this.gridCode = []
            this.areaId = ""
            post("/admin/org/info/findOrgGrid", {
                parentId: addId,
            }).then((res) => {
                console.log(res.content)
                this.gridCode = res.content.list
            })
        },
        async submit() {
            // 处理图片
            this.handleImgPost()
            const params = Object.assign({}, this.addfrom)
            console.log(this.addfrom)
            let photo = ""
            this.fileList.forEach((item) => {
                photo += item.path + ";"
            })
            params.leaders = this.member
            console.log(this.member)
            console.log("params", params)
            if (this.typeString == "insert") {
                console.log(this.typeString)
                let res = await insertPartyOrgBuild(params)
                if (res.code == 200) {
                    this.$message({
                        type: "success",
                        message: "新增成功",
                    })
                }
            } else {
                console.log(this.typeString)
                let res = await updatePartyOrgBuild(params)
                if (res.code == 200) {
                    this.$message({
                        type: "success",
                        message: "修改成功",
                    })
                }
            }
            this.clearadddata()
        },
        //根据输入地址转换经纬度并标记
        transLocation() {
            var searchKey = this.addfrom.address
            var map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 18,
            })
            var that = this
            AMap.plugin("AMap.Geocoder", function () {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all",
                })
                var marker = new AMap.Marker()
                geocoder.getLocation(searchKey, function (status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location
                        that.addfrom.longitude = String(lnglat.lng)
                        that.addfrom.latitude = String(lnglat.lat)
                        console.log("that.addfrom=>", that.addfrom)
                        marker.setPosition(lnglat)
                        map.add(marker)
                        map.setFitView(marker)
                    } else {
                        that.$message({
                            message: "获取坐标失败，请手动获取",
                            type: "error",
                        })
                        that.mapInit("container")
                    }
                })
                map.on("click", function (e) {
                    that.addfrom.longitude = String(e.lnglat.getLng())
                    that.addfrom.latitude = String(e.lnglat.getLat())
                    geocoder.getAddress(
                        e.lnglat.getLng() + "," + e.lnglat.getLat(),
                        function (status, result) {
                            // console.log(status);
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress
                                that.$set(that.addfrom, "address", address)
                            } else {
                                log.error("根据经纬度查询地址失败")
                            }
                        }
                    )
                })
            })
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            console.log("containerId", containerId)
            var map = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [119.013268, 32.6739],
            })
            // console.log(map);
            if (this.addfrom.longitude && this.addfrom.latitude) {
                var marker = new AMap.Marker({
                    position: [
                        Number(this.addfrom.longitude),
                        Number(this.addfrom.latitude),
                    ],
                    map: map,
                })
                map.setFitView(marker)
            } else {
                AMap.plugin("AMap.Geolocation", function () {
                    //异步定位当前
                    var geolocation = new AMap.Geolocation()
                    map.addControl(geolocation)
                })
            } //定义地图坐标点击事件
            var that = this
            var geocoder = new AMap.Geocoder({
                city: "010", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
            })
            map.on("click", function (e) {
                that.addfrom.longitude = String(e.lnglat.getLng())
                that.addfrom.latitude = String(e.lnglat.getLat())
                geocoder.getAddress(
                    e.lnglat.getLng() + "," + e.lnglat.getLat(),
                    function (status, result) {
                        // console.log(status);
                        if (status === "complete" && result.regeocode) {
                            var address = result.regeocode.formattedAddress
                            that.$set(that.addfrom, "address", address)
                        } else {
                            log.error("根据经纬度查询地址失败")
                        }
                    }
                )
            })
        },
        //根据网格获取地图地址数据的方法
        async getData(e) {
            const { content } = await post("/admin/org/info/findOrgById", {
                id: e,
            })
            //  this.addfrom.address=content.gridOfficeName
            this.$set(this.addfrom, "address", content.gridOfficeName)
            this.addfrom.longitude = content.gridOfficeCordinate.split(",")[0]
            this.addfrom.latitude = content.gridOfficeName.split(",")[1]
            this.mapInit("container")
        },
        //上传
        successUp(e) {
            this.fileList = e
        },
        updataPersonImg() {
            console.log(this.imgupdata)
            console.log(this.imgupdataimg)
            post("admin/consulType/info/updateConsultPerson", {
                id: this.imgupdata,
                photoPath: this.imgupdataimg,
            }).then((res) => {
                if (res.code == "200") {
                    console.log(res)
                }
            })
        },
        //删除
        deleteImg(e) {
            this.fileList = e
        },
        // 获取当前网格相关信息
        // getGridInfo(id) {
        //   return post("/admin/org/info/findOrgById", { id });
        // },
        // 上传图片
        async upimg(e) {
            if (e.target.files[0] == undefined) {
                return false
            } else {
                let res = await uploadPartyPhoto(e.target.files[0])
                // this.ruleForm.eddimgurl = res.content;
                this.$set(this.ruleForm, "photo", res.content)
                this.imgupdataimg = res.content
                console.log(res.content)
            }
        },
        // 图片上传成功
        imgSuccess(type, data, data1, data2) {
            this.hideUpload = false
            if (data) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            if (data.code === 200) {
                this.addfrom[type].push(data.content)
                // console.log(this.addfrom[type]);
            }
        },
        //上传图片方法
        handleRemove2(type, file, fileList) {
            console.log(fileList)
            this.hideUpload = false
            if (fileList.length) {
                this.hideUpload = true
            }
            console.log(this.hideUpload)
            this.addfrom[type].map((item, index) => {
                if (file.response != undefined) {
                    if (item == file.response.content) {
                        this.addfrom[type].splice(index, 1)
                    }
                } else {
                    if (item == file.url) {
                        this.addfrom[type].splice(index, 1)
                    }
                }
            })
        },
        handleRemove(file, fileList) {
            this.fileListimg.splice(index, 1)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        handleAvatarSuccess(res, file) {
            console.log(res)
            this.fileListimg.push(res.content)
            console.log(this.fileListimg)
        },
        searchPeopleReset() {
            this.searchPeopleList = {}
            this.getrenyuaInfo()
        },
        getrenyuaInfo() {
            let parmes = {
                ...this.searchPeopleList,
                menuType: "personInformationBase",
                pageSize: this.pageConfig.pageSize,
                pageNo: this.pageConfig.pageNo,
                status: 0,
                approvalStatus: 1,
            }
            post("/admin/consulType/info/findConsultPersonList", parmes).then(
                (res) => {
                    console.log(res)
                    if (res.code == 200) {
                        this.pageConfig.total = res.content.count
                        this.tableData = res.content.list
                        console.log(this.tableData)
                    } else {
                        console.log(res)
                        this.$message({
                            message: "数据加载异常：",
                            type: "error",
                        })
                    }
                    if (res.content.list.length) {
                        // 取出当前页数的选中table数据
                        let hadTableData = []
                        if (this.choosedata && this.choosedata.length) {
                            this.choosedata.forEach((row) => {
                                res.content.list.forEach((row1) => {
                                    if (row.id == row1.id) {
                                        //   this.checkedData.push(row1);
                                        hadTableData.push(row1)
                                    }
                                })
                            })
                        }

                        this.multipleSelectionFarher[
                            this.pageConfig.pageNo
                        ] = hadTableData
                        //   第一次显示父级传进来的数据的回显,如果有选中则以实际为准
                        //   console.log(this.multipleSelectionClick[this.pageConfig.pageNo]);
                        if (
                            !this.multipleSelectionClick[this.pageConfig.pageNo]
                        ) {
                            this.multipleSelection[
                                this.pageConfig.pageNo
                            ] = hadTableData
                        }

                        let newpagedata = []
                        res.content.list.forEach((row1) => {
                            this.multipleSelection[
                                this.pageConfig.pageNo
                            ].forEach((row2) => {
                                if (row1.id == row2.id) {
                                    //   this.checkedData.push(row1);
                                    newpagedata.push(row1)
                                }
                            })
                        })
                        this.multipleSelection[
                            this.pageConfig.pageNo
                        ] = newpagedata
                        this.checkedData = newpagedata
                        this.checkedTable()
                    }
                }
            )
        },
        checkedTable() {
            //   console.log("checkedData==t", this.checkedData);
            this.$nextTick(() => {
                this.checkedData.forEach((checked) => {
                    this.$refs.multipleTablePeo.toggleRowSelection(
                        checked,
                        true
                    )
                })
            })
        },
        //封装数据
        createData() {
            console.log(this.multipleSelection)
            let newdata = []
            for (const key in this.multipleSelection) {
                if (this.multipleSelection.hasOwnProperty(key)) {
                    newdata = newdata.concat(this.multipleSelection[key])
                }
            }
            let personTypeObj = this.searchGroups
            let objs = {
                parentPersonTypeId: personTypeObj.id,
                consultName: personTypeObj.consultName,
                persionArr: newdata,
            }
            this.$emit("func", objs)
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getrenyuaInfo()
        },
        // 预览图片
        handlePicturePreview(file) {
            this.dialogVisible1 = true
            this.dialogImageUrl = file.url
        },
    },
    mounted() {
        this.getrenyuaInfo()
        this.$nextTick(() => {
            setTimeout(() => {
                this.mapInit("container")
            }, 500)
        })
        //回显数据
        this.$nextTick(() => {
            this.tableData.forEach((row) => {
                if (this.selectListData.indexOf(row.id) >= 0) {
                    this.$refs.multipleTable.toggleRowSelection(row, true)
                }
            })
        })
        this.member = []
        console.log("=>", this.id)
        if (this.id && this.id > 0) {
            this.getDetail(this.id)
        }
    },
}
</script> 
<style lang="less" scoped>
.disabled .el-upload--picture-card {
    display: none !important;
}
.addres_input {
    width: 193px;
}
.el-input {
    width: auto;
}
.el-form {
    //display: flex;
    //flex-direction: column;
    //justify-content: center;
    //align-items: center;

    .dialog-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
}

.selectminisize {
    width: 100px;
    margin: 0 10px 0 0;
}

.avatar-uploader .avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.clacenter {
    text-align: center;
}
.winput450 {
    width: 450px;
    margin-bottom: 20px;
}
.input70 {
    width: 600px;
}
.lablewid_input {
    width: 187px;
}
.threestyleimgbtn {
    width: 80%;
    height: 30%;
    margin-top: 20px;

    // background-color: green;
    display: flex;
    // justify-content: center;
    // align-items: center;

    position: relative;
    div {
        width: 170px;
        height: 30%;
        background: #ffffff;
        border: 1px solid #cad4dc;
        text-align: center;
        line-height: 30px;
    }
    input {
        position: absolute;
        width: 172px;
        height: 32px;
        opacity: 0;
        cursor: pointer;
    }
}
.el-textarea {
    textarea {
        min-height: 85px;
    }
}
.hide {
    /deep/.el-upload--picture-card {
        display: none;
    }
}
</style>